import React from "react";
import ReactDOM from "react-dom/client";
// Initializes the error tracker
import "~/utils/errorTracker";
import App from "./App";

window.addEventListener("DOMContentLoaded", (e) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
